import React from 'react';

const categories = ['All', 'World', 'Technology', 'Environment', 'Business', 'Arts', 'Sports'];

export const FilterBar = ({ activeCategory, onCategoryChange }) => {
  return (
    <div 
      className="flex gap-2 overflow-x-auto pb-2 category-scroll"
      data-testid="filter-bar"
    >
      {categories.map((category) => (
        <button
          key={category}
          className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
          onClick={() => onCategoryChange(category)}
          data-testid={`filter-btn-${category.toLowerCase()}`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default FilterBar;
